// The demo bar's progress ring and its empty counterpart. These are drawings, not
// icons: the arc length is computed from done/total (a gauge), and the outline is that
// same ring at rest, the "not started" mark of a task row — so the file is on the
// icon guard's INLINE_SVG_ALLOWLIST (scripts/check-icon-vocabulary.mjs).
import { defineComponent, h } from 'vue';

export const RingOutlineIcon = defineComponent({
  name: 'DemoStageRingOutlineIcon',
  render: () => h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [h('circle', { cx: '12', cy: '12', r: '9' })]),
});
const RING_R = 7;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_R;
export const RingIcon = defineComponent({
  name: 'DemoStageRingIcon',
  props: { done: { type: Number, required: true }, total: { type: Number, required: true }, size: { type: Number, default: 18 } },
  render() {
    const fraction = this.total > 0 ? Math.min(1, this.done / this.total) : 0;
    return h('svg', { width: this.size, height: this.size, viewBox: '0 0 18 18', 'aria-hidden': 'true' }, [
      h('circle', { cx: 9, cy: 9, r: RING_R, fill: 'none', stroke: 'var(--band-track)', 'stroke-width': '2.5' }),
      h('circle', {
        cx: 9,
        cy: 9,
        r: RING_R,
        fill: 'none',
        stroke: 'var(--info)',
        'stroke-width': '2.5',
        'stroke-linecap': 'round',
        'stroke-dasharray': `${RING_CIRCUMFERENCE}`,
        'stroke-dashoffset': `${RING_CIRCUMFERENCE * (1 - fraction)}`,
        transform: 'rotate(-90 9 9)',
      }),
    ]);
  },
});
